import React, {useState, Fragment, useEffect} from "react";
import {Input, Label} from "reactstrap";
import ReactSelectDropDownCommon from "../../../../utils/SuperAdmin/ReactSelectDropDownCommon";
import FromLoader from "../../../../utils/SuperAdmin/Loader/FromLoader";
import CommonModal from "../../../../utils/SuperAdmin/CommonModal";

const AssignCompanyResultModal = ({
                                       modalOpen,
                                       companyOptions,
                                       selectedUser,
                                       companyModalClose,
                                       assignLoading,
                                       submit,
                                   }) => {
    const [selectedCompany, setSelectedCompany] = useState([]);

    const handleCompanyChange = (newSelection) => {
        const uniqueSelection = Array.from(
            new Map(newSelection.map(item => [item.value, item])).values()
        );
        setSelectedCompany(uniqueSelection);
    };

    useEffect(() => {
        if (modalOpen && selectedUser?.companies && companyOptions?.length > 0) {
            const assignedCompanyNames = selectedUser.companies.split(",").map(c => c.trim());

            const preselected = companyOptions.filter(opt =>
                assignedCompanyNames.includes(opt.label)
            );

            // Only update if different
            if (JSON.stringify(preselected) !== JSON.stringify(selectedCompany)) {
                setSelectedCompany(preselected);
            }
        }
    }, [modalOpen, selectedUser, companyOptions]);



    const submitEmployee = () => {
        submit(selectedCompany ,selectedUser)
    }

    const modalContent = (
        <>
            {assignLoading ? (<>
                <FromLoader/>
            </>) : (<>
                <Label for="user_email">User Email</Label>
                <Input disabled type="email" value={selectedUser?.email} name="user_email"/>

                <Label className="mt-2" for="assign_location">
                    Assign Company *
                </Label>
                <ReactSelectDropDownCommon
                    isMulti
                    placeholder="Assign Company "
                    isSearchable={true}
                    value={selectedCompany}
                    onChange={handleCompanyChange}
                    options={companyOptions}
                />
            </>)}
        </>
    );

    return (
        <Fragment>
            <CommonModal
                show={modalOpen}
                title="Assign Location"
                content={modalContent}
                backdrop="static"
                keyboard={false}
                closeButtonFlag
                handleClose={companyModalClose}
                submitEmployee={submitEmployee}
                flag={false}
                applyButton
            />
        </Fragment>
    );
};

export default AssignCompanyResultModal;
